import { Mail, Globe, Building2, ArrowUpRight, Phone } from "lucide-react";

const CARDS = [
  { icon: Mail,      label: "Email",      value: "beerappa@fortifyhub.net",       href: "mailto:beerappa@fortifyhub.net" },
  { icon: Phone,     label: "Phone",      value: "+91 70287 00361",                href: "tel:+917028700361" },
  { icon: Globe,     label: "Arventiq Labs", value: "arventiqlabs.com",            href: "https://arventiqlabs.com" },
  { icon: Building2, label: "Campus",     value: "BMSIT&M, Yelahanka, Bengaluru",  href: null },
];

export default function Contact() {
  return (
    <div className="mx-auto max-w-4xl px-6 lg:px-14 pt-8 pb-24">
      <div className="max-w-2xl">
        <div className="overline text-cobalt-500">Contact</div>
        <h1 className="mt-2 font-display text-5xl sm:text-6xl font-black tracking-tighter leading-[0.95]">
          Bring it to<br />your campus.
        </h1>
        <p className="mt-5 text-lg text-muted-foreground leading-relaxed">
          Built and maintained by Arventiq Labs. Reach out to set up the events platform for your
          institution, or for help with an existing deployment.
        </p>
      </div>

      <div className="mt-12 grid sm:grid-cols-2 gap-5">
        {CARDS.map((c) => {
          const Icon = c.icon;
          const inner = (
            <div className="glass rounded-2xl p-6 h-full hover:-translate-y-1 transition-transform relative overflow-hidden">
              <div className="absolute -top-10 -right-10 h-28 w-28 rounded-full bg-cobalt-500/10 blur-2xl" />
              <div className="relative">
                <div className="h-11 w-11 rounded-xl bg-cobalt-500/10 text-cobalt-500 grid place-items-center"><Icon className="h-5 w-5" /></div>
                <div className="overline mt-4">{c.label}</div>
                <div className="mt-1 font-medium text-sm flex items-center gap-1 break-all">
                  {c.value}{c.href && <ArrowUpRight className="h-3.5 w-3.5 opacity-50 shrink-0" />}
                </div>
              </div>
            </div>
          );
          return c.href
            ? <a key={c.label} href={c.href} target="_blank" rel="noreferrer" className="block">{inner}</a>
            : <div key={c.label}>{inner}</div>;
        })}
      </div>

      <div className="mt-10 glass-strong rounded-3xl p-8 flex items-center gap-4 relative overflow-hidden">
        <div className="absolute -top-12 -left-12 h-40 w-40 rounded-full bg-cyanx/20 blur-3xl" />
        <div className="relative flex items-center gap-4 w-full">
          <span className="text-[9px] text-mono uppercase tracking-widest text-muted-foreground">Powered by</span>
          <img src="/brand/arventiq-full.png" alt="Arventiq Labs" className="h-7 w-auto dark:brightness-0 dark:invert" />
          <span className="ml-auto text-mono uppercase tracking-widest text-xs text-muted-foreground">Innovate · Learn · Secure</span>
        </div>
      </div>
    </div>
  );
}
